import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const AttachmentDownloadedAuditItemDetails = ({ audit }) => {
  const { attachmentName } = audit

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> downloaded
        { attachmentName ? ` the file ${attachmentName}` : " a file"}.
      </span>
    </div>
  )
}

AttachmentDownloadedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AttachmentDownloadedAuditItemDetails
